import React from 'react';
import { TabsItem } from 'components/Tabs';
import Flex, { Grid } from 'components/Flex';
import ICarInvolved from 'interfaces/carInvolved';

import { CarIcon } from '../../../../styles/icons';
import { WrapperName, LineTitle } from './styles';

interface InvolvedCarData {
  detailCarInvolved: ICarInvolved[];
}

const CarsDetail: React.FC<InvolvedCarData> = ({ detailCarInvolved }) => {
  const involvedCars = detailCarInvolved;

  return (
    <TabsItem title="Veículos Envolvidos">
      <Grid container justify="flex-start" spacing={1}>
        {involvedCars?.map((involvedCar) => (
          <Grid item key={involvedCar.id}>
            <LineTitle>
              <Grid container spacing={1}>
                  <WrapperName>
                    <CarIcon />&nbsp;{involvedCar.plate}
                  </WrapperName>
                <Flex title="Motivação" xs={12} sm={6} md={4}>
                  {involvedCar.motivation}
                </Flex>

                <Flex title="Chassi (Mín 5 Caracter)" xs={12} sm={6} md={4}>
                  {involvedCar.chassi}
                </Flex>

                <Flex title="Marca" xs={12} sm={6} md={4}>
                  {involvedCar.brand}
                </Flex>

                <Flex title="Modelo" xs={12} sm={6} md={4}>
                  {involvedCar.model}
                </Flex>

                <Flex title="Cor" xs={12} sm={6} md={4}>
                  {involvedCar.color}
                </Flex>

                <Flex title="CRLV" xs={12} sm={6} md={4}>
                  {involvedCar.crlv}
                </Flex>

                <Flex title="Ano exercício" xs={12} sm={6} md={4}>
                  {involvedCar.exercise}
                </Flex>

                <Flex title="Condutor" xs={12} sm={6} md={4}>
                  {involvedCar.conductor}
                </Flex>

                <Flex title="CNH" xs={12} sm={6} md={4}>
                  {involvedCar.cnh}
                </Flex>

                <Flex title="Categoria" xs={12} sm={6} md={4}>
                  {involvedCar.category}
                </Flex>

                <Flex title="UF" xs={12} sm={6} md={4}>
                  {involvedCar.uf}
                </Flex>

                <Flex title="Auto de Infração" xs={12} sm={6} md={6}>
                  {involvedCar.infringement}
                </Flex>

                <Flex title="Relacionamento ao envolvido" xs={12} sm={6} md={6}>
                  {involvedCar.name}
                </Flex>

              </Grid>
            </LineTitle>
          </Grid>
        ))}
      </Grid>
    </TabsItem>
  );
};

export default CarsDetail;
